module.exports = __webpack_public_path__ + "static/media/sujitha.952e5c2e.jpg";